// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"85":"852db9b5","840":"6f840f04"}[chunkId] + ".js";
};